module.exports = __webpack_public_path__ + "static/connie-d7265812869732497199814d245d58d7.jpeg";